import { useCallback, useEffect, useState } from 'react';
import styles from './profile.module.scss';
import Header from '@components/header/HeaHeader';
import { TextInput, TextInputValue } from '@components/text-input/TextInput';
import Button from '@components/button/Button';
import Switch from '@src/components/swtich/Switch';
import PasscodeModal from './add-modal/PasscodeModal';
import { useHeaUpdateMeMutation, useHeaMeLazyQuery, useHeaDeleteAccountMutation } from '@src/api/graphql-codegen';
import Footer from '@src/components/footer/Footer';
import DeleteModal from './delete-modal/DeleteModal';
import { useHistory } from 'react-router-dom';
import { showSuccessNotification } from '@hooks/useNotification';
import PasswordModal from './add-modal/PasswordModal';
import { useAuthToken } from '@src/hooks/useAuthToken';
import BackIcon from '@src/assets/icons/arrow_back.svg?react';
import { logger } from '../../../utils/logger';
import FooterPage from '@src/components/footer-page/FooterPage';

type Props = {};

function Profile(props: Props) {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [passcode, setPasscode] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [update, setUpdate] = useState(false)
  const [enableFaith, setEnableFaith] = useState(false);
  const [studyplanId, setstudyplanId] = useState('0');

  const history = useHistory()
  const { password: authPassword, removeAuthPassword, removeVisitProfile, setVisitProfile } = useAuthToken()

    const [heaUpdateMe, {loading: loadingUpdate}] = useHeaUpdateMeMutation({
    onCompleted: (res) => {
      if (res.heaUpdateMe) {
        showSuccessNotification('You have successfully updated your profile.');
      }
    }
  });
  const [heaDeleteAccount, {loading: deleting}] = useHeaDeleteAccountMutation({
    onCompleted: (res) => {
      if (res.heaDeleteAccount) {
        setDeleteModal(true)
        removeAuthPassword();
        removeVisitProfile();
        history.replace("/login");
      }
    },
    onError(e) {
      logger.debug(`[e]`, e);
      alert('Something went wrong.');
    }
  });
  const [getUser, {data, loading}] = useHeaMeLazyQuery({
    fetchPolicy: 'network-only',
  });

  useEffect(() => {
    getUser();
  }, [getUser])

  useEffect(() => {
    if (data?.heaMe) {
      data.heaMe.firstName && setFirstName(data.heaMe.firstName);
      data.heaMe.lastName && setLastName(data.heaMe.lastName);
      data.heaMe.enableFaith && setEnableFaith(data.heaMe.enableFaith);
      data.heaMe.studyplanId && setstudyplanId(data.heaMe.studyplanId);
    }
  }, [data?.heaMe]);

  const handleChangeInput = useCallback((setter) => (value: TextInputValue) => {
    setter(value);
  }, []);

  const gotoDashboard = async() => {
    if (data?.heaMe?.firstName !== firstName || data.heaMe.lastName !== lastName) {
      const update = await heaUpdateMe({
        variables: {
          input: {
            firstName,
            lastName,
            enableFaith,
            enablePasscode: !!passcode,
            passcode
          }
        },
      });

      if (update.data?.heaUpdateMe) {
        setVisitProfile('YES');
        history.replace("/studyplan");
      }
    } else {
      setVisitProfile('YES');
      history.replace("/studyplan");
    }
  }

  const save = useCallback(() => {
    try {
      heaUpdateMe({
        variables: {
          input: {
            firstName,
            lastName,
            enableFaith,
            enablePasscode: !!passcode,
            passcode
          }
        },
      });
    } catch (e) {
      logger.debug(`[e]`, e);
    }
  },[heaUpdateMe, firstName, lastName, enableFaith, passcode]);

  useEffect(() => {
    if (update) {
      save()
      setUpdate(false)
    }
  }, [update, save, setUpdate, enableFaith])

  const handleFaithEnable = () => {
    setEnableFaith(current => !current)
    setUpdate(true)
  }

  const handlePasscode = (passcode: string) => {
    setPasscode(passcode)
    setShowModal(false)
    setUpdate(true)
  }

  const handleDeleteAccount = () => {
    heaDeleteAccount()
  }

  return (
    <>
      <Header isProfile={true}/>
      <div className={styles.page}>
        <div className={styles.headerTitle}>Profile</div>
        <div className={styles.pageContent}>
          <div className={styles.profileContent}>
            <div className={styles.row}>
              <TextInput placeholder={'First Name'} label={'First Name:'} id={'firstName'} value={firstName}
                         onChange={handleChangeInput(setFirstName)}/>
              <TextInput placeholder={'Last Name'} label={'Last Name:'} id={'lastName'} value={lastName}
                         onChange={handleChangeInput(setLastName)}/>
            </div>
            <div className={styles.emailWrapper}>
              <span className={styles.email}>Email:&nbsp;</span>{data?.heaMe?.email}
            </div>
            <div className={styles.subWrapper}>
              <span className={styles.subText}>Faith Units:</span>
              <Switch onChange={handleFaithEnable} enabled={enableFaith} />
            </div>
            {!authPassword &&<div className={styles.emailWrapper}>
            <span className={styles.subText}>Password set?:&nbsp;</span>{!!authPassword ? 'YES' : 'No'}
              <div className={styles.passcodeText}>
              Please set your password to protect your account.
              </div>
            </div>}
            <Button disabled={loading || loadingUpdate} className={ authPassword ? styles.passwordBtn : styles.passCodeBtn} label={!!authPassword ? 'Reset Password' : 'Set Password'} onClick={() => setShowPasswordModal(true)}/>
            {false && (<>
              <div className={styles.emailWrapper}>
                <span className={styles.subText}>Passcode set?:&nbsp;</span>{!!passcode ? 'YES' : 'No'}
                <div className={styles.passcodeText}>
                Setting your passcode will make it quicker and easier to lock your account when you active your study plan for your child.
                </div>
              </div>
              {!authPassword && <div className={styles.passcodeText}>Note: Please create your Password first.</div>}
              <Button disabled={loading || loadingUpdate} className={authPassword ? styles.passCodeBtn : styles.passcodeDisableBtn} label={!!passcode ? 'Reset Passcode' : 'Set Passcode'} onClick={() => setShowModal(true)}/>
              </>)}
            <div className={styles.buttons}>
              <Button disabled={loading || loadingUpdate} className={styles.backBtn} leftIcon={<BackIcon width={18} height={18} className={styles.backButton}/>} label={'Return'} onClick={gotoDashboard}/>
              <Button disabled={loading || loadingUpdate} className={styles.btn} isLoading={loadingUpdate} label={'Save'} onClick={save}/>
            </div>
          </div>
        </div>
        <div className={styles.deleteRow}>
          <Button className={styles.deleteButton} disabled={loading || loadingUpdate} onClick={() => {setDeleteModal(true)}} label={'DELETE ACCOUNT'}/>
        </div>
        <FooterPage />
      </div>
      {showModal && <PasscodeModal open={showModal} onClose={() => setShowModal(false)} passcode={passcode} handleSetPasscode={handlePasscode}/>}
      {showPasswordModal && <PasswordModal open={showPasswordModal} onClose={() => setShowPasswordModal(false)} studyplanId={studyplanId}/>}
      {deleteModal && <DeleteModal open={deleteModal} onClose={() => setDeleteModal(false)} deleting={deleting} onDeleteAccount={handleDeleteAccount} />}
      {/* <Footer /> */}
    </>
  );
}

export default Profile;
